import React, { useState, useMemo } from 'react';
import { List, ListItem, ListItemText, Checkbox, makeStyles } from '@material-ui/core';
import { Input } from 'reactstrap';

// Datos de ejemplo (deberías cargarlos de tu API)
const tiposDocumentalesDisponibles = [
  { id: 93, title: 'Avisos de prensa' },
  { id: 94, title: 'Balance General' },
  { id: 95, title: 'Banco de Proyectos' },
  { id: 96, title: 'Banco Terminológico de series y subseries documentales' },
  { id: 97, title: 'Boleta citación' },
  { id: 98, title: 'Boletín Epidemiológico Municipal' },
  { id: 99, title: 'Cartografía oficial' },
  { id: 100, title: 'Certificaciones de Retiro de EPS' },
  { id: 101, title: 'Certificación bancaria' },
  // ... (otros documentos)
];

const useStyles = makeStyles({
  searchBox: {
    marginBottom: 10,
    maxWidth:"40%",
    className:"table__search table__search-input"
  },
  listContainer: {
    maxHeight: 300, // Altura fija con scroll para simular tu panel
    maxWidth: "100%",
    overflowY: 'auto',
    border: '1px solid #ccc',
    borderRadius: 4,
  },
  listItem: {
    padding: '1px 16px',
  },
});

export function SelectorTiposDocumentales({ selectedDocs, setSelectedDocs }) {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState('');

  // 1. Lógica de Filtrado (La Búsqueda)
  const filteredDocs = useMemo(() => {
    if (!searchTerm) return tiposDocumentalesDisponibles;
    
    const lowerCaseSearch = searchTerm.toLowerCase();
    
    return tiposDocumentalesDisponibles.filter(doc =>
      doc.title.toLowerCase().includes(lowerCaseSearch) ||
      String(doc.id).includes(lowerCaseSearch) // Permite buscar por ID también
    );
  }, [searchTerm]);

  // 2. Lógica de Selección Múltiple
  const handleToggle = (documento) => () => {
    const currentIndex = selectedDocs.findIndex(d => d.id === documento.id);
    const newSelectedDocs = [...selectedDocs];

    if (currentIndex === -1) {
      newSelectedDocs.push(documento); // Agregar
    } else {
      newSelectedDocs.splice(currentIndex, 1); // Remover
    }

    setSelectedDocs(newSelectedDocs);
  };

  return (
    <>
      <Input
        className={classes.searchBox}
        placeholder={`Buscar...`}
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {/* Lista de Resultados con Scroll (simulando tu panel) */}
      <div className={classes.listContainer}>
        <List dense component="div" role="list">
          {filteredDocs.map((documento) => {
            const isChecked = selectedDocs.some(d => d.id === documento.id);
            const labelId = `checkbox-list-label-${documento.id}`;

            return (
              <ListItem
                key={documento.id}
                role="listitem"
                button
                onClick={handleToggle(documento)}
                className={classes.listItem}
              >
                {/* ID del Documento (como en tu imagen) */}
                <ListItemText id={labelId} primary={documento.id} style={{ flex: '0 0 50px' }} />
                
                {/* Nombre del Documento */}
                <ListItemText primary={documento.title} />
                
                {/* Casilla de Verificación */}
                <Checkbox
                  edge="end"
                  checked={isChecked}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItem>
            );
          })}
        </List>
        {filteredDocs.length === 0 && <ListItem><ListItemText secondary="No se encontraron documentos." /></ListItem>}
      </div>
    </>
  );
}